import { GETBALANCE_SUCCESS, GETBALANCE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getBalanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETBALANCE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETBALANCE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getBalanceReducer;
